import { render, staticRenderFns } from "./participantSetting.vue?vue&type=template&id=0a408e5a&scoped=true"
import script from "./participantSetting.vue?vue&type=script&lang=js"
export * from "./participantSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a408e5a",
  null
  
)

export default component.exports